import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import Me from '@/plugins/graphql/queries/me.gql';
let PasswordDialog = class PasswordDialog extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.password = '';
        this.email = '';
    }
    get invalid() {
        return !this.email || !this.password;
    }
    /**
     * event handler if component is confirmed
     */
    validatePassword() {
        if (!this.invalid) {
            this.$emit('auth:valid', [this.email, this.password]);
            this.password = '';
        }
    }
    onCancel() {
        this.password = '';
        this.$emit('input', false);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], PasswordDialog.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PasswordDialog.prototype, "value", void 0);
PasswordDialog = __decorate([
    Component({
        components: {
            ActionButton,
        },
        apollo: {
            email: {
                query: Me,
                update: (data) => {
                    return data.me.email;
                },
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], PasswordDialog);
export default PasswordDialog;
